var _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _mask5, _g5, _mask6, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 195,
    viewBox: "0 0 240 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_61_1339",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.16667C0 0.970052 0.97005 0 2.16667 0H62.8333C64.0299 0 65 0.97005 65 2.16667V19.5C72.1797 19.5 78 25.3203 78 32.5C78 39.6797 72.1797 45.5 65 45.5V62.8333C65 64.0299 64.03 65 62.8333 65H45.5C45.5 57.8203 39.6797 52 32.5 52C25.3203 52 19.5 57.8203 19.5 65H2.16667C0.970052 65 0 64.03 0 62.8333V2.16667Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_61_1339)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.16667C0 0.970052 0.97005 0 2.16667 0H62.8333C64.0299 0 65 0.97005 65 2.16667V19.5C72.1797 19.5 78 25.3203 78 32.5C78 39.6797 72.1797 45.5 65 45.5V62.8333C65 64.0299 64.03 65 62.8333 65H45.5C45.5 57.8203 39.6797 52 32.5 52C25.3203 52 19.5 57.8203 19.5 65H2.16667C0.970052 65 0 64.03 0 62.8333V2.16667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.16667C0 0.970052 0.97005 0 2.16667 0H62.8333C64.0299 0 65 0.97005 65 2.16667V19.5C72.1797 19.5 78 25.3203 78 32.5C78 39.6797 72.1797 45.5 65 45.5V62.8333C65 64.0299 64.03 65 62.8333 65H45.5C45.5 57.8203 39.6797 52 32.5 52C25.3203 52 19.5 57.8203 19.5 65H2.16667C0.970052 65 0 64.03 0 62.8333V2.16667Z",
    fill: "url(#paint0_linear_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.16667C0 0.970052 0.97005 0 2.16667 0H62.8333C64.0299 0 65 0.97005 65 2.16667V19.5C72.1797 19.5 78 25.3203 78 32.5C78 39.6797 72.1797 45.5 65 45.5V62.8333C65 64.0299 64.03 65 62.8333 65H45.5C45.5 57.8203 39.6797 52 32.5 52C25.3203 52 19.5 57.8203 19.5 65H2.16667C0.970052 65 0 64.03 0 62.8333V2.16667Z",
    fill: "url(#paint1_linear_61_1339)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65 19.5H63.9167V20.5833H65V19.5ZM65 45.5V44.4167H63.9167V45.5H65ZM45.5 65H44.4167V66.0833H45.5V65ZM19.5 65V66.0833H20.5833V65H19.5ZM2.16667 -1.08333C0.37174 -1.08333 -1.08333 0.371744 -1.08333 2.16667H1.08333C1.08333 1.56836 1.56836 1.08333 2.16667 1.08333V-1.08333ZM62.8333 -1.08333H2.16667V1.08333H62.8333V-1.08333ZM66.0833 2.16667C66.0833 0.371739 64.6283 -1.08333 62.8333 -1.08333V1.08333C63.4316 1.08333 63.9167 1.56836 63.9167 2.16667H66.0833ZM66.0833 19.5V2.16667H63.9167V19.5H66.0833ZM65 20.5833C71.5814 20.5833 76.9167 25.9186 76.9167 32.5H79.0833C79.0833 24.722 72.778 18.4167 65 18.4167V20.5833ZM76.9167 32.5C76.9167 39.0814 71.5814 44.4167 65 44.4167V46.5833C72.778 46.5833 79.0833 40.278 79.0833 32.5H76.9167ZM66.0833 62.8333V45.5H63.9167V62.8333H66.0833ZM62.8333 66.0833C64.6283 66.0833 66.0833 64.6283 66.0833 62.8333H63.9167C63.9167 63.4316 63.4316 63.9167 62.8333 63.9167V66.0833ZM45.5 66.0833H62.8333V63.9167H45.5V66.0833ZM32.5 53.0833C39.0814 53.0833 44.4167 58.4186 44.4167 65H46.5833C46.5833 57.222 40.278 50.9167 32.5 50.9167V53.0833ZM20.5833 65C20.5833 58.4186 25.9186 53.0833 32.5 53.0833V50.9167C24.722 50.9167 18.4167 57.222 18.4167 65H20.5833ZM2.16667 66.0833H19.5V63.9167H2.16667V66.0833ZM-1.08333 62.8333C-1.08333 64.6283 0.371745 66.0833 2.16667 66.0833V63.9167C1.56836 63.9167 1.08333 63.4316 1.08333 62.8333H-1.08333ZM-1.08333 2.16667V62.8333H1.08333V2.16667H-1.08333Z",
    fill: "url(#paint2_linear_61_1339)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-2-inside-1_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 19.5H63.9167V20.5833H65V19.5ZM65 45.5V44.4167H63.9167V45.5H65ZM45.5 65H44.4167V66.0833H45.5V65ZM19.5 65V66.0833H20.5833V65H19.5ZM2.16667 -1.08333C0.37174 -1.08333 -1.08333 0.371744 -1.08333 2.16667H1.08333C1.08333 1.56836 1.56836 1.08333 2.16667 1.08333V-1.08333ZM62.8333 -1.08333H2.16667V1.08333H62.8333V-1.08333ZM66.0833 2.16667C66.0833 0.371739 64.6283 -1.08333 62.8333 -1.08333V1.08333C63.4316 1.08333 63.9167 1.56836 63.9167 2.16667H66.0833ZM66.0833 19.5V2.16667H63.9167V19.5H66.0833ZM65 20.5833C71.5814 20.5833 76.9167 25.9186 76.9167 32.5H79.0833C79.0833 24.722 72.778 18.4167 65 18.4167V20.5833ZM76.9167 32.5C76.9167 39.0814 71.5814 44.4167 65 44.4167V46.5833C72.778 46.5833 79.0833 40.278 79.0833 32.5H76.9167ZM66.0833 62.8333V45.5H63.9167V62.8333H66.0833ZM62.8333 66.0833C64.6283 66.0833 66.0833 64.6283 66.0833 62.8333H63.9167C63.9167 63.4316 63.4316 63.9167 62.8333 63.9167V66.0833ZM45.5 66.0833H62.8333V63.9167H45.5V66.0833ZM32.5 53.0833C39.0814 53.0833 44.4167 58.4186 44.4167 65H46.5833C46.5833 57.222 40.278 50.9167 32.5 50.9167V53.0833ZM20.5833 65C20.5833 58.4186 25.9186 53.0833 32.5 53.0833V50.9167C24.722 50.9167 18.4167 57.222 18.4167 65H20.5833ZM2.16667 66.0833H19.5V63.9167H2.16667V66.0833ZM-1.08333 62.8333C-1.08333 64.6283 0.371745 66.0833 2.16667 66.0833V63.9167C1.56836 63.9167 1.08333 63.4316 1.08333 62.8333H-1.08333ZM-1.08333 2.16667V62.8333H1.08333V2.16667H-1.08333Z",
    fill: "#FAFAFA",
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-2-inside-1_61_1339)"
  }), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_61_1339",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1667 0C65.97 0 65 0.970052 65 2.16667V19.5C72.1797 19.5 78 25.3203 78 32.5C78 39.6797 72.1797 45.5 65 45.5V62.8333C65 64.03 65.9701 65 67.1667 65H84.5C84.5 72.1797 90.3203 78 97.5 78C104.68 78 110.5 72.1797 110.5 65H127.833C129.03 65 130 64.0299 130 62.8333V45.5C137.18 45.5 143 39.6797 143 32.5C143 25.3203 137.18 19.5 130 19.5V2.16667C130 0.97005 129.03 0 127.833 0H67.1667Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_61_1339)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1667 0C65.97 0 65 0.970052 65 2.16667V19.5C72.1797 19.5 78 25.3203 78 32.5C78 39.6797 72.1797 45.5 65 45.5V62.8333C65 64.03 65.9701 65 67.1667 65H84.5C84.5 72.1797 90.3203 78 97.5 78C104.68 78 110.5 72.1797 110.5 65H127.833C129.03 65 130 64.0299 130 62.8333V45.5C137.18 45.5 143 39.6797 143 32.5C143 25.3203 137.18 19.5 130 19.5V2.16667C130 0.97005 129.03 0 127.833 0H67.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1667 0C65.97 0 65 0.970052 65 2.16667V19.5C72.1797 19.5 78 25.3203 78 32.5C78 39.6797 72.1797 45.5 65 45.5V62.8333C65 64.03 65.9701 65 67.1667 65H84.5C84.5 72.1797 90.3203 78 97.5 78C104.68 78 110.5 72.1797 110.5 65H127.833C129.03 65 130 64.0299 130 62.8333V45.5C137.18 45.5 143 39.6797 143 32.5C143 25.3203 137.18 19.5 130 19.5V2.16667C130 0.97005 129.03 0 127.833 0H67.1667Z",
    fill: "url(#paint3_linear_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1667 0C65.97 0 65 0.970052 65 2.16667V19.5C72.1797 19.5 78 25.3203 78 32.5C78 39.6797 72.1797 45.5 65 45.5V62.8333C65 64.03 65.9701 65 67.1667 65H84.5C84.5 72.1797 90.3203 78 97.5 78C104.68 78 110.5 72.1797 110.5 65H127.833C129.03 65 130 64.0299 130 62.8333V45.5C137.18 45.5 143 39.6797 143 32.5C143 25.3203 137.18 19.5 130 19.5V2.16667C130 0.97005 129.03 0 127.833 0H67.1667Z",
    fill: "url(#paint4_linear_61_1339)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65 19.5H63.9167V20.5833H65V19.5ZM65 45.5V44.4167H63.9167V45.5H65ZM84.5 65H85.5833V63.9167H84.5V65ZM110.5 65V63.9167H109.417V65H110.5ZM130 45.5V44.4167H128.917V45.5H130ZM130 19.5H128.917V20.5833H130V19.5ZM66.0833 2.16667C66.0833 1.56836 66.5684 1.08333 67.1667 1.08333V-1.08333C65.3717 -1.08333 63.9167 0.371744 63.9167 2.16667H66.0833ZM66.0833 19.5V2.16667H63.9167V19.5H66.0833ZM79.0833 32.5C79.0833 24.722 72.778 18.4167 65 18.4167V20.5833C71.5814 20.5833 76.9167 25.9186 76.9167 32.5H79.0833ZM65 46.5833C72.778 46.5833 79.0833 40.278 79.0833 32.5H76.9167C76.9167 39.0814 71.5814 44.4167 65 44.4167V46.5833ZM66.0833 62.8333V45.5H63.9167V62.8333H66.0833ZM67.1667 63.9167C66.5684 63.9167 66.0833 63.4316 66.0833 62.8333H63.9167C63.9167 64.6283 65.3717 66.0833 67.1667 66.0833V63.9167ZM84.5 63.9167H67.1667V66.0833H84.5V63.9167ZM97.5 76.9167C90.9186 76.9167 85.5833 71.5814 85.5833 65H83.4167C83.4167 72.778 89.722 79.0833 97.5 79.0833V76.9167ZM109.417 65C109.417 71.5814 104.081 76.9167 97.5 76.9167V79.0833C105.278 79.0833 111.583 72.778 111.583 65H109.417ZM127.833 63.9167H110.5V66.0833H127.833V63.9167ZM128.917 62.8333C128.917 63.4316 128.432 63.9167 127.833 63.9167V66.0833C129.628 66.0833 131.083 64.6283 131.083 62.8333H128.917ZM128.917 45.5V62.8333H131.083V45.5H128.917ZM141.917 32.5C141.917 39.0814 136.581 44.4167 130 44.4167V46.5833C137.778 46.5833 144.083 40.278 144.083 32.5H141.917ZM130 20.5833C136.581 20.5833 141.917 25.9186 141.917 32.5H144.083C144.083 24.722 137.778 18.4167 130 18.4167V20.5833ZM128.917 2.16667V19.5H131.083V2.16667H128.917ZM127.833 1.08333C128.432 1.08333 128.917 1.56836 128.917 2.16667H131.083C131.083 0.371739 129.628 -1.08333 127.833 -1.08333V1.08333ZM67.1667 1.08333H127.833V-1.08333H67.1667V1.08333Z",
    fill: "url(#paint5_linear_61_1339)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-4-inside-2_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 19.5H63.9167V20.5833H65V19.5ZM65 45.5V44.4167H63.9167V45.5H65ZM84.5 65H85.5833V63.9167H84.5V65ZM110.5 65V63.9167H109.417V65H110.5ZM130 45.5V44.4167H128.917V45.5H130ZM130 19.5H128.917V20.5833H130V19.5ZM66.0833 2.16667C66.0833 1.56836 66.5684 1.08333 67.1667 1.08333V-1.08333C65.3717 -1.08333 63.9167 0.371744 63.9167 2.16667H66.0833ZM66.0833 19.5V2.16667H63.9167V19.5H66.0833ZM79.0833 32.5C79.0833 24.722 72.778 18.4167 65 18.4167V20.5833C71.5814 20.5833 76.9167 25.9186 76.9167 32.5H79.0833ZM65 46.5833C72.778 46.5833 79.0833 40.278 79.0833 32.5H76.9167C76.9167 39.0814 71.5814 44.4167 65 44.4167V46.5833ZM66.0833 62.8333V45.5H63.9167V62.8333H66.0833ZM67.1667 63.9167C66.5684 63.9167 66.0833 63.4316 66.0833 62.8333H63.9167C63.9167 64.6283 65.3717 66.0833 67.1667 66.0833V63.9167ZM84.5 63.9167H67.1667V66.0833H84.5V63.9167ZM97.5 76.9167C90.9186 76.9167 85.5833 71.5814 85.5833 65H83.4167C83.4167 72.778 89.722 79.0833 97.5 79.0833V76.9167ZM109.417 65C109.417 71.5814 104.081 76.9167 97.5 76.9167V79.0833C105.278 79.0833 111.583 72.778 111.583 65H109.417ZM127.833 63.9167H110.5V66.0833H127.833V63.9167ZM128.917 62.8333C128.917 63.4316 128.432 63.9167 127.833 63.9167V66.0833C129.628 66.0833 131.083 64.6283 131.083 62.8333H128.917ZM128.917 45.5V62.8333H131.083V45.5H128.917ZM141.917 32.5C141.917 39.0814 136.581 44.4167 130 44.4167V46.5833C137.778 46.5833 144.083 40.278 144.083 32.5H141.917ZM130 20.5833C136.581 20.5833 141.917 25.9186 141.917 32.5H144.083C144.083 24.722 137.778 18.4167 130 18.4167V20.5833ZM128.917 2.16667V19.5H131.083V2.16667H128.917ZM127.833 1.08333C128.432 1.08333 128.917 1.56836 128.917 2.16667H131.083C131.083 0.371739 129.628 -1.08333 127.833 -1.08333V1.08333ZM67.1667 1.08333H127.833V-1.08333H67.1667V1.08333Z",
    fill: "#FAFAFA",
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-4-inside-2_61_1339)"
  }), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_61_1339",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.167 0C130.97 0 130 0.970052 130 2.16667V19.5C137.18 19.5 143 25.3203 143 32.5C143 39.6797 137.18 45.5 130 45.5V62.8333C130 64.03 130.97 65 132.167 65H149.5C149.5 72.1797 155.32 78 162.5 78C169.68 78 175.5 72.1797 175.5 65H192.833C194.03 65 195 64.0299 195 62.8333V45.5C187.82 45.5 182 39.6797 182 32.5C182 25.3203 187.82 19.5 195 19.5V2.16667C195 0.97005 194.03 0 192.833 0H132.167Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_61_1339)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.167 0C130.97 0 130 0.970052 130 2.16667V19.5C137.18 19.5 143 25.3203 143 32.5C143 39.6797 137.18 45.5 130 45.5V62.8333C130 64.03 130.97 65 132.167 65H149.5C149.5 72.1797 155.32 78 162.5 78C169.68 78 175.5 72.1797 175.5 65H192.833C194.03 65 195 64.0299 195 62.8333V45.5C187.82 45.5 182 39.6797 182 32.5C182 25.3203 187.82 19.5 195 19.5V2.16667C195 0.97005 194.03 0 192.833 0H132.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.167 0C130.97 0 130 0.970052 130 2.16667V19.5C137.18 19.5 143 25.3203 143 32.5C143 39.6797 137.18 45.5 130 45.5V62.8333C130 64.03 130.97 65 132.167 65H149.5C149.5 72.1797 155.32 78 162.5 78C169.68 78 175.5 72.1797 175.5 65H192.833C194.03 65 195 64.0299 195 62.8333V45.5C187.82 45.5 182 39.6797 182 32.5C182 25.3203 187.82 19.5 195 19.5V2.16667C195 0.97005 194.03 0 192.833 0H132.167Z",
    fill: "url(#paint6_linear_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.167 0C130.97 0 130 0.970052 130 2.16667V19.5C137.18 19.5 143 25.3203 143 32.5C143 39.6797 137.18 45.5 130 45.5V62.8333C130 64.03 130.97 65 132.167 65H149.5C149.5 72.1797 155.32 78 162.5 78C169.68 78 175.5 72.1797 175.5 65H192.833C194.03 65 195 64.0299 195 62.8333V45.5C187.82 45.5 182 39.6797 182 32.5C182 25.3203 187.82 19.5 195 19.5V2.16667C195 0.97005 194.03 0 192.833 0H132.167Z",
    fill: "url(#paint7_linear_61_1339)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M130 19.5H128.917V20.5833H130V19.5ZM130 45.5V44.4167H128.917V45.5H130ZM149.5 65H150.583V63.9167H149.5V65ZM175.5 65V63.9167H174.417V65H175.5ZM195 45.5H196.083V44.4167H195V45.5ZM195 19.5V20.5833H196.083V19.5H195ZM131.083 2.16667C131.083 1.56836 131.568 1.08333 132.167 1.08333V-1.08333C130.372 -1.08333 128.917 0.371744 128.917 2.16667H131.083ZM131.083 19.5V2.16667H128.917V19.5H131.083ZM144.083 32.5C144.083 24.722 137.778 18.4167 130 18.4167V20.5833C136.581 20.5833 141.917 25.9186 141.917 32.5H144.083ZM130 46.5833C137.778 46.5833 144.083 40.278 144.083 32.5H141.917C141.917 39.0814 136.581 44.4167 130 44.4167V46.5833ZM131.083 62.8333V45.5H128.917V62.8333H131.083ZM132.167 63.9167C131.568 63.9167 131.083 63.4316 131.083 62.8333H128.917C128.917 64.6283 130.372 66.0833 132.167 66.0833V63.9167ZM149.5 63.9167H132.167V66.0833H149.5V63.9167ZM162.5 76.9167C155.919 76.9167 150.583 71.5814 150.583 65H148.417C148.417 72.778 154.722 79.0833 162.5 79.0833V76.9167ZM174.417 65C174.417 71.5814 169.081 76.9167 162.5 76.9167V79.0833C170.278 79.0833 176.583 72.778 176.583 65H174.417ZM192.833 63.9167H175.5V66.0833H192.833V63.9167ZM193.917 62.8333C193.917 63.4316 193.432 63.9167 192.833 63.9167V66.0833C194.628 66.0833 196.083 64.6283 196.083 62.8333H193.917ZM193.917 45.5V62.8333H196.083V45.5H193.917ZM180.917 32.5C180.917 40.278 187.222 46.5833 195 46.5833V44.4167C188.419 44.4167 183.083 39.0814 183.083 32.5H180.917ZM195 18.4167C187.222 18.4167 180.917 24.722 180.917 32.5H183.083C183.083 25.9186 188.419 20.5833 195 20.5833V18.4167ZM193.917 2.16667V19.5H196.083V2.16667H193.917ZM192.833 1.08333C193.432 1.08333 193.917 1.56836 193.917 2.16667H196.083C196.083 0.371739 194.628 -1.08333 192.833 -1.08333V1.08333ZM132.167 1.08333H192.833V-1.08333H132.167V1.08333Z",
    fill: "url(#paint8_linear_61_1339)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-6-inside-3_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 19.5H128.917V20.5833H130V19.5ZM130 45.5V44.4167H128.917V45.5H130ZM149.5 65H150.583V63.9167H149.5V65ZM175.5 65V63.9167H174.417V65H175.5ZM195 45.5H196.083V44.4167H195V45.5ZM195 19.5V20.5833H196.083V19.5H195ZM131.083 2.16667C131.083 1.56836 131.568 1.08333 132.167 1.08333V-1.08333C130.372 -1.08333 128.917 0.371744 128.917 2.16667H131.083ZM131.083 19.5V2.16667H128.917V19.5H131.083ZM144.083 32.5C144.083 24.722 137.778 18.4167 130 18.4167V20.5833C136.581 20.5833 141.917 25.9186 141.917 32.5H144.083ZM130 46.5833C137.778 46.5833 144.083 40.278 144.083 32.5H141.917C141.917 39.0814 136.581 44.4167 130 44.4167V46.5833ZM131.083 62.8333V45.5H128.917V62.8333H131.083ZM132.167 63.9167C131.568 63.9167 131.083 63.4316 131.083 62.8333H128.917C128.917 64.6283 130.372 66.0833 132.167 66.0833V63.9167ZM149.5 63.9167H132.167V66.0833H149.5V63.9167ZM162.5 76.9167C155.919 76.9167 150.583 71.5814 150.583 65H148.417C148.417 72.778 154.722 79.0833 162.5 79.0833V76.9167ZM174.417 65C174.417 71.5814 169.081 76.9167 162.5 76.9167V79.0833C170.278 79.0833 176.583 72.778 176.583 65H174.417ZM192.833 63.9167H175.5V66.0833H192.833V63.9167ZM193.917 62.8333C193.917 63.4316 193.432 63.9167 192.833 63.9167V66.0833C194.628 66.0833 196.083 64.6283 196.083 62.8333H193.917ZM193.917 45.5V62.8333H196.083V45.5H193.917ZM180.917 32.5C180.917 40.278 187.222 46.5833 195 46.5833V44.4167C188.419 44.4167 183.083 39.0814 183.083 32.5H180.917ZM195 18.4167C187.222 18.4167 180.917 24.722 180.917 32.5H183.083C183.083 25.9186 188.419 20.5833 195 20.5833V18.4167ZM193.917 2.16667V19.5H196.083V2.16667H193.917ZM192.833 1.08333C193.432 1.08333 193.917 1.56836 193.917 2.16667H196.083C196.083 0.371739 194.628 -1.08333 192.833 -1.08333V1.08333ZM132.167 1.08333H192.833V-1.08333H132.167V1.08333Z",
    fill: "#FAFAFA",
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-6-inside-3_61_1339)"
  }), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_61_1339",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16667 65C0.97005 65 0 65.9701 0 67.1667V127.833C0 129.03 0.970052 130 2.16667 130H19.5C19.5 122.82 25.3203 117 32.5 117C39.6797 117 45.5 122.82 45.5 130H62.8333C64.03 130 65 129.03 65 127.833V67.1667C65 65.97 64.0299 65 62.8333 65H2.16667Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_61_1339)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16667 65C0.97005 65 0 65.9701 0 67.1667V127.833C0 129.03 0.970052 130 2.16667 130H19.5C19.5 122.82 25.3203 117 32.5 117C39.6797 117 45.5 122.82 45.5 130H62.8333C64.03 130 65 129.03 65 127.833V67.1667C65 65.97 64.0299 65 62.8333 65H2.16667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16667 65C0.97005 65 0 65.9701 0 67.1667V127.833C0 129.03 0.970052 130 2.16667 130H19.5C19.5 122.82 25.3203 117 32.5 117C39.6797 117 45.5 122.82 45.5 130H62.8333C64.03 130 65 129.03 65 127.833V67.1667C65 65.97 64.0299 65 62.8333 65H2.16667Z",
    fill: "url(#paint9_linear_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16667 65C0.97005 65 0 65.9701 0 67.1667V127.833C0 129.03 0.970052 130 2.16667 130H19.5C19.5 122.82 25.3203 117 32.5 117C39.6797 117 45.5 122.82 45.5 130H62.8333C64.03 130 65 129.03 65 127.833V67.1667C65 65.97 64.0299 65 62.8333 65H2.16667Z",
    fill: "url(#paint10_linear_61_1339)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 130V131.083H20.5833V130H19.5ZM45.5 130H44.4167V131.083H45.5V130ZM1.08333 67.1667C1.08333 66.5684 1.56836 66.0833 2.16667 66.0833V63.9167C0.37174 63.9167 -1.08333 65.3717 -1.08333 67.1667H1.08333ZM1.08333 127.833V67.1667H-1.08333V127.833H1.08333ZM2.16667 128.917C1.56836 128.917 1.08333 128.432 1.08333 127.833H-1.08333C-1.08333 129.628 0.371745 131.083 2.16667 131.083V128.917ZM19.5 128.917H2.16667V131.083H19.5V128.917ZM20.5833 130C20.5833 123.419 25.9186 118.083 32.5 118.083V115.917C24.722 115.917 18.4167 122.222 18.4167 130H20.5833ZM32.5 118.083C39.0814 118.083 44.4167 123.419 44.4167 130H46.5833C46.5833 122.222 40.278 115.917 32.5 115.917V118.083ZM62.8333 128.917H45.5V131.083H62.8333V128.917ZM63.9167 127.833C63.9167 128.432 63.4316 128.917 62.8333 128.917V131.083C64.6283 131.083 66.0833 129.628 66.0833 127.833H63.9167ZM63.9167 67.1667V127.833H66.0833V67.1667H63.9167ZM62.8333 66.0833C63.4316 66.0833 63.9167 66.5684 63.9167 67.1667H66.0833C66.0833 65.3717 64.6283 63.9167 62.8333 63.9167V66.0833ZM2.16667 66.0833H62.8333V63.9167H2.16667V66.0833Z",
    fill: "url(#paint11_linear_61_1339)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-8-inside-4_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 130V131.083H20.5833V130H19.5ZM45.5 130H44.4167V131.083H45.5V130ZM1.08333 67.1667C1.08333 66.5684 1.56836 66.0833 2.16667 66.0833V63.9167C0.37174 63.9167 -1.08333 65.3717 -1.08333 67.1667H1.08333ZM1.08333 127.833V67.1667H-1.08333V127.833H1.08333ZM2.16667 128.917C1.56836 128.917 1.08333 128.432 1.08333 127.833H-1.08333C-1.08333 129.628 0.371745 131.083 2.16667 131.083V128.917ZM19.5 128.917H2.16667V131.083H19.5V128.917ZM20.5833 130C20.5833 123.419 25.9186 118.083 32.5 118.083V115.917C24.722 115.917 18.4167 122.222 18.4167 130H20.5833ZM32.5 118.083C39.0814 118.083 44.4167 123.419 44.4167 130H46.5833C46.5833 122.222 40.278 115.917 32.5 115.917V118.083ZM62.8333 128.917H45.5V131.083H62.8333V128.917ZM63.9167 127.833C63.9167 128.432 63.4316 128.917 62.8333 128.917V131.083C64.6283 131.083 66.0833 129.628 66.0833 127.833H63.9167ZM63.9167 67.1667V127.833H66.0833V67.1667H63.9167ZM62.8333 66.0833C63.4316 66.0833 63.9167 66.5684 63.9167 67.1667H66.0833C66.0833 65.3717 64.6283 63.9167 62.8333 63.9167V66.0833ZM2.16667 66.0833H62.8333V63.9167H2.16667V66.0833Z",
    fill: "#FAFAFA",
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-8-inside-4_61_1339)"
  }), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-5_61_1339",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.833 65H110.5C110.5 57.8203 104.68 52 97.5 52C90.3203 52 84.5 57.8203 84.5 65H67.1667C65.97 65 65 65.9701 65 67.1667V127.833C65 129.03 65.9701 130 67.1667 130H84.5C84.5 137.18 90.3203 143 97.5 143C104.68 143 110.5 137.18 110.5 130H127.833C129.03 130 130 129.03 130 127.833V110.5C122.82 110.5 117 104.68 117 97.5C117 90.3203 122.82 84.5 130 84.5V67.1667C130 65.97 129.03 65 127.833 65Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_61_1339)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.833 65H110.5C110.5 57.8203 104.68 52 97.5 52C90.3203 52 84.5 57.8203 84.5 65H67.1667C65.97 65 65 65.9701 65 67.1667V127.833C65 129.03 65.9701 130 67.1667 130H84.5C84.5 137.18 90.3203 143 97.5 143C104.68 143 110.5 137.18 110.5 130H127.833C129.03 130 130 129.03 130 127.833V110.5C122.82 110.5 117 104.68 117 97.5C117 90.3203 122.82 84.5 130 84.5V67.1667C130 65.97 129.03 65 127.833 65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.833 65H110.5C110.5 57.8203 104.68 52 97.5 52C90.3203 52 84.5 57.8203 84.5 65H67.1667C65.97 65 65 65.9701 65 67.1667V127.833C65 129.03 65.9701 130 67.1667 130H84.5C84.5 137.18 90.3203 143 97.5 143C104.68 143 110.5 137.18 110.5 130H127.833C129.03 130 130 129.03 130 127.833V110.5C122.82 110.5 117 104.68 117 97.5C117 90.3203 122.82 84.5 130 84.5V67.1667C130 65.97 129.03 65 127.833 65Z",
    fill: "url(#paint12_linear_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.833 65H110.5C110.5 57.8203 104.68 52 97.5 52C90.3203 52 84.5 57.8203 84.5 65H67.1667C65.97 65 65 65.9701 65 67.1667V127.833C65 129.03 65.9701 130 67.1667 130H84.5C84.5 137.18 90.3203 143 97.5 143C104.68 143 110.5 137.18 110.5 130H127.833C129.03 130 130 129.03 130 127.833V110.5C122.82 110.5 117 104.68 117 97.5C117 90.3203 122.82 84.5 130 84.5V67.1667C130 65.97 129.03 65 127.833 65Z",
    fill: "url(#paint13_linear_61_1339)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 65H109.417V66.0833H110.5V65ZM84.5 65V66.0833H85.5833V65H84.5ZM84.5 130H85.5833V128.917H84.5V130ZM110.5 130V128.917H109.417V130H110.5ZM130 110.5H131.083V109.417H130V110.5ZM130 84.5V85.5833H131.083V84.5H130ZM110.5 66.0833H127.833V63.9167H110.5V66.0833ZM97.5 53.0833C104.081 53.0833 109.417 58.4186 109.417 65H111.583C111.583 57.222 105.278 50.9167 97.5 50.9167V53.0833ZM85.5833 65C85.5833 58.4186 90.9186 53.0833 97.5 53.0833V50.9167C89.722 50.9167 83.4167 57.222 83.4167 65H85.5833ZM67.1667 66.0833H84.5V63.9167H67.1667V66.0833ZM66.0833 67.1667C66.0833 66.5684 66.5684 66.0833 67.1667 66.0833V63.9167C65.3717 63.9167 63.9167 65.3717 63.9167 67.1667H66.0833ZM66.0833 127.833V67.1667H63.9167V127.833H66.0833ZM67.1667 128.917C66.5684 128.917 66.0833 128.432 66.0833 127.833H63.9167C63.9167 129.628 65.3717 131.083 67.1667 131.083V128.917ZM84.5 128.917H67.1667V131.083H84.5V128.917ZM97.5 141.917C90.9186 141.917 85.5833 136.581 85.5833 130H83.4167C83.4167 137.778 89.722 144.083 97.5 144.083V141.917ZM109.417 130C109.417 136.581 104.081 141.917 97.5 141.917V144.083C105.278 144.083 111.583 137.778 111.583 130H109.417ZM127.833 128.917H110.5V131.083H127.833V128.917ZM128.917 127.833C128.917 128.432 128.432 128.917 127.833 128.917V131.083C129.628 131.083 131.083 129.628 131.083 127.833H128.917ZM128.917 110.5V127.833H131.083V110.5H128.917ZM115.917 97.5C115.917 105.278 122.222 111.583 130 111.583V109.417C123.419 109.417 118.083 104.081 118.083 97.5H115.917ZM130 83.4167C122.222 83.4167 115.917 89.722 115.917 97.5H118.083C118.083 90.9186 123.419 85.5833 130 85.5833V83.4167ZM128.917 67.1667V84.5H131.083V67.1667H128.917ZM127.833 66.0833C128.432 66.0833 128.917 66.5684 128.917 67.1667H131.083C131.083 65.3717 129.628 63.9167 127.833 63.9167V66.0833Z",
    fill: "url(#paint14_linear_61_1339)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-10-inside-5_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 65H109.417V66.0833H110.5V65ZM84.5 65V66.0833H85.5833V65H84.5ZM84.5 130H85.5833V128.917H84.5V130ZM110.5 130V128.917H109.417V130H110.5ZM130 110.5H131.083V109.417H130V110.5ZM130 84.5V85.5833H131.083V84.5H130ZM110.5 66.0833H127.833V63.9167H110.5V66.0833ZM97.5 53.0833C104.081 53.0833 109.417 58.4186 109.417 65H111.583C111.583 57.222 105.278 50.9167 97.5 50.9167V53.0833ZM85.5833 65C85.5833 58.4186 90.9186 53.0833 97.5 53.0833V50.9167C89.722 50.9167 83.4167 57.222 83.4167 65H85.5833ZM67.1667 66.0833H84.5V63.9167H67.1667V66.0833ZM66.0833 67.1667C66.0833 66.5684 66.5684 66.0833 67.1667 66.0833V63.9167C65.3717 63.9167 63.9167 65.3717 63.9167 67.1667H66.0833ZM66.0833 127.833V67.1667H63.9167V127.833H66.0833ZM67.1667 128.917C66.5684 128.917 66.0833 128.432 66.0833 127.833H63.9167C63.9167 129.628 65.3717 131.083 67.1667 131.083V128.917ZM84.5 128.917H67.1667V131.083H84.5V128.917ZM97.5 141.917C90.9186 141.917 85.5833 136.581 85.5833 130H83.4167C83.4167 137.778 89.722 144.083 97.5 144.083V141.917ZM109.417 130C109.417 136.581 104.081 141.917 97.5 141.917V144.083C105.278 144.083 111.583 137.778 111.583 130H109.417ZM127.833 128.917H110.5V131.083H127.833V128.917ZM128.917 127.833C128.917 128.432 128.432 128.917 127.833 128.917V131.083C129.628 131.083 131.083 129.628 131.083 127.833H128.917ZM128.917 110.5V127.833H131.083V110.5H128.917ZM115.917 97.5C115.917 105.278 122.222 111.583 130 111.583V109.417C123.419 109.417 118.083 104.081 118.083 97.5H115.917ZM130 83.4167C122.222 83.4167 115.917 89.722 115.917 97.5H118.083C118.083 90.9186 123.419 85.5833 130 85.5833V83.4167ZM128.917 67.1667V84.5H131.083V67.1667H128.917ZM127.833 66.0833C128.432 66.0833 128.917 66.5684 128.917 67.1667H131.083C131.083 65.3717 129.628 63.9167 127.833 63.9167V66.0833Z",
    fill: "#FAFAFA",
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-10-inside-5_61_1339)"
  }), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-6_61_1339",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.599 110.149C160.441 115.451 160.067 123.674 154.766 128.515C149.464 133.356 141.241 132.983 136.4 127.681L123.6 139.369C122.716 140.176 122.654 141.546 123.461 142.43L135.149 155.23C140.451 150.389 148.674 150.762 153.515 156.064C158.356 161.366 157.983 169.588 152.681 174.43L164.369 187.229C165.176 188.113 166.546 188.175 167.43 187.368L180.23 175.68C185.071 180.982 193.294 181.355 198.596 176.514C203.898 171.673 204.271 163.45 199.43 158.148L212.229 146.46C213.113 145.653 213.175 144.283 212.368 143.399L200.68 130.599C205.982 125.758 206.355 117.535 201.514 112.234C196.673 106.932 188.45 106.558 183.148 111.4L171.46 98.6C170.653 97.7164 169.283 97.6541 168.399 98.461L155.599 110.149Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_61_1339)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.599 110.149C160.441 115.451 160.067 123.674 154.766 128.515C149.464 133.356 141.241 132.983 136.4 127.681L123.6 139.369C122.716 140.176 122.654 141.546 123.461 142.43L135.149 155.23C140.451 150.389 148.674 150.762 153.515 156.064C158.356 161.366 157.983 169.588 152.681 174.43L164.369 187.229C165.176 188.113 166.546 188.175 167.43 187.368L180.23 175.68C185.071 180.982 193.294 181.355 198.596 176.514C203.898 171.673 204.271 163.45 199.43 158.148L212.229 146.46C213.113 145.653 213.175 144.283 212.368 143.399L200.68 130.599C205.982 125.758 206.355 117.535 201.514 112.234C196.673 106.932 188.45 106.558 183.148 111.4L171.46 98.6C170.653 97.7164 169.283 97.6541 168.399 98.461L155.599 110.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.599 110.149C160.441 115.451 160.067 123.674 154.766 128.515C149.464 133.356 141.241 132.983 136.4 127.681L123.6 139.369C122.716 140.176 122.654 141.546 123.461 142.43L135.149 155.23C140.451 150.389 148.674 150.762 153.515 156.064C158.356 161.366 157.983 169.588 152.681 174.43L164.369 187.229C165.176 188.113 166.546 188.175 167.43 187.368L180.23 175.68C185.071 180.982 193.294 181.355 198.596 176.514C203.898 171.673 204.271 163.45 199.43 158.148L212.229 146.46C213.113 145.653 213.175 144.283 212.368 143.399L200.68 130.599C205.982 125.758 206.355 117.535 201.514 112.234C196.673 106.932 188.45 106.558 183.148 111.4L171.46 98.6C170.653 97.7164 169.283 97.6541 168.399 98.461L155.599 110.149Z",
    fill: "url(#paint15_linear_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.599 110.149C160.441 115.451 160.067 123.674 154.766 128.515C149.464 133.356 141.241 132.983 136.4 127.681L123.6 139.369C122.716 140.176 122.654 141.546 123.461 142.43L135.149 155.23C140.451 150.389 148.674 150.762 153.515 156.064C158.356 161.366 157.983 169.588 152.681 174.43L164.369 187.229C165.176 188.113 166.546 188.175 167.43 187.368L180.23 175.68C185.071 180.982 193.294 181.355 198.596 176.514C203.898 171.673 204.271 163.45 199.43 158.148L212.229 146.46C213.113 145.653 213.175 144.283 212.368 143.399L200.68 130.599C205.982 125.758 206.355 117.535 201.514 112.234C196.673 106.932 188.45 106.558 183.148 111.4L171.46 98.6C170.653 97.7164 169.283 97.6541 168.399 98.461L155.599 110.149Z",
    fill: "url(#paint16_linear_61_1339)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.599 110.149C160.441 115.451 160.067 123.674 154.766 128.515C149.464 133.356 141.241 132.983 136.4 127.681L123.6 139.369C122.716 140.176 122.654 141.546 123.461 142.43L135.149 155.23C140.451 150.389 148.674 150.762 153.515 156.064C158.356 161.366 157.983 169.588 152.681 174.43L164.369 187.229C165.176 188.113 166.546 188.175 167.43 187.368L180.23 175.68C185.071 180.982 193.294 181.355 198.596 176.514C203.898 171.673 204.271 163.45 199.43 158.148L212.229 146.46C213.113 145.653 213.175 144.283 212.368 143.399L200.68 130.599C205.982 125.758 206.355 117.535 201.514 112.234C196.673 106.932 188.45 106.558 183.148 111.4L171.46 98.6C170.653 97.7164 169.283 97.6541 168.399 98.461L155.599 110.149Z",
    fill: "url(#paint17_linear_61_1339)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M155.599 110.149L154.869 109.349L154.069 110.08L154.799 110.88L155.599 110.149ZM136.4 127.681L137.2 126.951L136.469 126.151L135.669 126.881L136.4 127.681ZM123.6 139.369L122.869 138.569L123.6 139.369ZM123.461 142.43L122.661 143.161L123.461 142.43ZM135.149 155.23L134.349 155.96L135.08 156.76L135.88 156.03L135.149 155.23ZM152.681 174.43L151.951 173.63L151.151 174.36L151.881 175.16L152.681 174.43ZM164.369 187.229L163.569 187.96L164.369 187.229ZM167.43 187.368L168.161 188.168L167.43 187.368ZM180.23 175.68L181.03 174.95L180.299 174.15L179.499 174.88L180.23 175.68ZM199.43 158.148L198.699 157.348L197.899 158.079L198.63 158.879L199.43 158.148ZM212.229 146.46L211.499 145.66L212.229 146.46ZM200.68 130.599L199.95 129.799L199.15 130.53L199.88 131.33L200.68 130.599ZM183.148 111.4L182.348 112.13L183.079 112.93L183.879 112.2L183.148 111.4ZM155.496 129.315C161.24 124.07 161.644 115.162 156.399 109.419L154.799 110.88C159.237 115.74 158.895 123.277 154.035 127.715L155.496 129.315ZM135.6 128.412C140.845 134.155 149.752 134.56 155.496 129.315L154.035 127.715C149.175 132.153 141.638 131.811 137.2 126.951L135.6 128.412ZM124.33 140.169L137.13 128.481L135.669 126.881L122.869 138.569L124.33 140.169ZM124.261 141.7C123.858 141.258 123.889 140.573 124.33 140.169L122.869 138.569C121.544 139.779 121.451 141.835 122.661 143.161L124.261 141.7ZM135.949 154.499L124.261 141.7L122.661 143.161L134.349 155.96L135.949 154.499ZM154.315 155.333C149.07 149.59 140.162 149.185 134.419 154.43L135.88 156.03C140.74 151.592 148.277 151.934 152.715 156.794L154.315 155.333ZM153.412 175.23C159.155 169.985 159.56 161.077 154.315 155.333L152.715 156.794C157.153 161.654 156.811 169.192 151.951 173.63L153.412 175.23ZM165.169 186.499L153.481 173.699L151.881 175.16L163.569 187.96L165.169 186.499ZM166.7 186.568C166.258 186.972 165.572 186.941 165.169 186.499L163.569 187.96C164.779 189.285 166.835 189.379 168.161 188.168L166.7 186.568ZM179.499 174.88L166.7 186.568L168.161 188.168L180.96 176.48L179.499 174.88ZM197.865 175.714C193.005 180.152 185.468 179.81 181.03 174.95L179.43 176.411C184.675 182.154 193.583 182.559 199.326 177.314L197.865 175.714ZM198.63 158.879C203.067 163.739 202.725 171.276 197.865 175.714L199.326 177.314C205.07 172.069 205.474 163.161 200.23 157.418L198.63 158.879ZM211.499 145.66L198.699 157.348L200.16 158.948L212.96 147.26L211.499 145.66ZM211.568 144.13C211.972 144.572 211.941 145.257 211.499 145.66L212.96 147.26C214.285 146.05 214.379 143.994 213.168 142.669L211.568 144.13ZM199.88 131.33L211.568 144.13L213.168 142.669L201.48 129.869L199.88 131.33ZM200.714 112.964C205.152 117.824 204.81 125.362 199.95 129.799L201.411 131.399C207.154 126.155 207.559 117.247 202.314 111.503L200.714 112.964ZM183.879 112.2C188.739 107.762 196.276 108.104 200.714 112.964L202.314 111.503C197.069 105.759 188.161 105.355 182.418 110.6L183.879 112.2ZM170.66 99.3305L182.348 112.13L183.948 110.669L172.26 97.8695L170.66 99.3305ZM169.13 99.261C169.572 98.8576 170.257 98.8887 170.66 99.3305L172.26 97.8695C171.05 96.544 168.994 96.4507 167.669 97.661L169.13 99.261ZM156.33 110.949L169.13 99.261L167.669 97.661L154.869 109.349L156.33 110.949Z",
    fill: "url(#paint18_linear_61_1339)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "soft-light"
    },
    mask: "url(#path-12-inside-6_61_1339)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_61_1339",
    x: 0,
    y: -3.25,
    width: 78,
    height: 79.0833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.8333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.41667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_61_1339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_61_1339",
    result: "effect2_innerShadow_61_1339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_61_1339",
    x: 65,
    y: -3.25,
    width: 78,
    height: 92.0833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.8333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.41667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_61_1339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_61_1339",
    result: "effect2_innerShadow_61_1339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_61_1339",
    x: 130,
    y: -3.25,
    width: 65,
    height: 92.0833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.8333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.41667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_61_1339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_61_1339",
    result: "effect2_innerShadow_61_1339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_61_1339",
    x: 0,
    y: 61.75,
    width: 65,
    height: 79.0833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.8333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.41667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_61_1339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_61_1339",
    result: "effect2_innerShadow_61_1339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_61_1339",
    x: 65,
    y: 48.75,
    width: 65,
    height: 105.083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.8333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.41667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_61_1339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_61_1339",
    result: "effect2_innerShadow_61_1339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_61_1339",
    x: 122.894,
    y: 94.6443,
    width: 90.0406,
    height: 104.124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.8333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.41667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_61_1339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_61_1339",
    result: "effect2_innerShadow_61_1339"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_1339",
    x1: 39,
    y1: 0,
    x2: 39,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_1339",
    x1: 39,
    y1: 0,
    x2: 39,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_1339",
    x1: 39,
    y1: 0,
    x2: 39,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_1339",
    x1: 104,
    y1: 0,
    x2: 104,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_61_1339",
    x1: 104,
    y1: 0,
    x2: 104,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_61_1339",
    x1: 104,
    y1: 0,
    x2: 104,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_61_1339",
    x1: 162.5,
    y1: 0,
    x2: 162.5,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_61_1339",
    x1: 162.5,
    y1: 0,
    x2: 162.5,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_61_1339",
    x1: 162.5,
    y1: 0,
    x2: 162.5,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_61_1339",
    x1: 32.5,
    y1: 65,
    x2: 32.5,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_61_1339",
    x1: 32.5,
    y1: 65,
    x2: 32.5,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_61_1339",
    x1: 32.5,
    y1: 65,
    x2: 32.5,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_61_1339",
    x1: 97.5,
    y1: 52,
    x2: 97.5,
    y2: 143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_61_1339",
    x1: 97.5,
    y1: 52,
    x2: 97.5,
    y2: 143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_61_1339",
    x1: 97.5,
    y1: 52,
    x2: 97.5,
    y2: 143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_61_1339",
    x1: 150.8,
    y1: 114.532,
    x2: 203.396,
    y2: 172.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_61_1339",
    x1: 180.557,
    y1: 187.1,
    x2: 173.614,
    y2: 93.6996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_61_1339",
    x1: 150.8,
    y1: 114.532,
    x2: 203.396,
    y2: 172.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_61_1339",
    x1: 150.8,
    y1: 114.532,
    x2: 203.396,
    y2: 172.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.a8c01cccbcc48dd892291ab973c2af7b.svg";
export { ForwardRef as ReactComponent };